@if (socialPromo$ | async; as promo) {
  <div class="social">
    <div class="social__inner">
      <div class="left">
        @if (!isLinksOnly()) {
          <div class="social__inner_title">{{promo[0]?.Title}}</div>
          <div class="social__inner_description">{{promo[0]?.Description}}</div>
        }
        <div class="social__inner_actions">
          @if (promo[0]?.DiscordBtnLink; as url) {
            <a [href]="url" target="_blank">
              <img loading="lazy" src="/assets/img/social-redesign/discord.png" alt="discord" class="discord">
            </a>
          }
          @if (promo[0]?.FacebookBtnLink; as url) {
            <a [href]="url" target="_blank">
              <img loading="lazy" src="/assets/img/social-redesign/facebook.png" alt="facebook" class="facebook" />
            </a>
          }
          @if (promo[0]?.YouTubeBtnLink; as url) {
            <a [href]="url" target="_blank">
              <img loading="lazy" src="/assets/img/social-redesign/youtube.png" alt="youtube" class="youtube" />
            </a>
          }
          @if (promo[0]?.WhatsAppBtnLink; as url) {
            <a [href]="url" target="_blank">
              <img loading="lazy" src="/assets/img/social-redesign/whatsapp.png" alt="whatsapp" class="whatsapp" />
            </a>
          }
          @if (promo[0]?.TelegramBtnLink; as url) {
            <a [href]="url" target="_blank">
              <img loading="lazy" src="/assets/img/social-redesign/telegram.png" alt="telegram" class="telegram">
            </a>
          }
          @if (promo[0]?.TwitterBtnLink; as url) {
            <a [href]="url" target="_blank">
              <img loading="lazy" src="/assets/img/social-redesign/twitter.png" alt="twitter" class="twitter">
            </a>
          }
          @if (promo[0]?.InstagramBtnLink; as url) {
            <a [href]="url" target="_blank">
              <img loading="lazy" src="/assets/img/social-redesign/instagram.png" alt="instagram" class="instagram">
            </a>
          }
        </div>
      </div>
      @if (!isLinksOnly()) {
        <div class="right">
          <img class="telegram-img" [src]="promo[0]?.Img" alt="telegram">
        </div>
      }
    </div>
  </div>
}

